module.exports = __webpack_public_path__ + "img/30.35ca6813.jpg";